import { useFormContext } from '@/app/workflows/components/v6/operations/settings/form/contexts/formContext';
import { NumberInput, Stack } from '@mantine/core';
import { SettingTitle } from '@/app/workflows/components/v6/operations/settings/form/components/SettingTitle';

const path = 'uvUnwrapping.uvScale';

export function UvScaleSetting() {
  const form = useFormContext();

  const isEnabled = !form.values.uvUnwrapping?.method;

  return (
    <Stack gap='xs'>
      <SettingTitle title='UV Scale' description='Specified UV scale for unwrapping method "cube" in meters' />
      <NumberInput min={0.001} max={100} w={100} {...form.getInputProps(path)} disabled={isEnabled} />
    </Stack>
  );
}
